/** Lead source label → icon filename under /assets/img/icons/. */
const LEAD_SOURCE_ICON_FILES: Record<string, string> = {
  bot: 'bot.svg',
  chatbot: 'chatbot.svg',
  'channel partner': 'channel_partner.svg',
  channel_partner: 'channel_partner.svg',
  'chat form': 'chat_form.svg',
  chat_form: 'chat_form.svg',
  conference: 'conference.svg',
  'field visit': 'field_visit.svg',
  'site visit': 'field_visit.svg',
  field_visit: 'field_visit.svg',
  site_visit: 'field_visit.svg',
  google: 'google.svg',
  instagram: 'instagram.svg',
  intern: 'intern.svg',
  'landing page': 'landing_page.svg',
  landing_page: 'landing_page.svg',
  'lead gen tools': 'lead_gen_tools.svg',
  'lead gen tool': 'lead_gen_tools.svg',
  lead_gen_tools: 'lead_gen_tools.svg',
  linkedin: 'linkedin.svg',
  'live session': 'live_session.svg',
  live_session: 'live_session.svg',
  other: 'other.svg',
  personal: 'personal.svg',
  telephony: 'telephony.svg',
  phone: 'telephony.svg',
  referral: 'referral.svg',
  'document scan': 'document_scan.svg',
  'scan document': 'document_scan.svg',
  document_scan: 'document_scan.svg',
  simulator: 'simulator.svg',
  tina: 'tina.svg',
  'voice agent': 'voice_agent.svg',
  voice_agent: 'voice_agent.svg',
  webform: 'webform.svg',
  'web form': 'webform.svg',
  website: 'website.svg',
  web: 'website.svg',
  whatsapp: 'whatsapp.svg',
  hubspot: 'hubspot.svg',
  'hubspot crm': 'hubspot.svg',
  zoho: 'zoho.svg',
  'zoho crm': 'zoho.svg',
  pipedrive: 'pipedrive.svg',
  freshdesk: 'freshdesk.svg',
  freshsales: 'freshdesk.svg',
  'freshdesk crm': 'freshdesk.svg',
  'freshsales crm': 'freshdesk.svg',
  'freshdesk / freshsales': 'freshdesk.svg',
  freshworks: 'freshdesk.svg',
};

const CRM_SOURCE_ICON_MATCHERS: Array<{ needle: string; file: string }> = [
  { needle: 'hubspot', file: 'hubspot.svg' },
  { needle: 'zoho', file: 'zoho.svg' },
  { needle: 'pipedrive', file: 'pipedrive.svg' },
  { needle: 'freshdesk', file: 'freshdesk.svg' },
  { needle: 'freshsales', file: 'freshdesk.svg' },
  { needle: 'freshworks', file: 'freshdesk.svg' },
];

function normalizeLeadSourceKey(source?: string | null): string {
  return String(source ?? '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
}

export function getLeadSourceIconFile(source?: string | null): string | null {
  const key = normalizeLeadSourceKey(source);
  if (!key) {
    return null;
  }

  if (LEAD_SOURCE_ICON_FILES[key]) {
    return LEAD_SOURCE_ICON_FILES[key];
  }

  const underscored = key.replace(/\s+/g, '_');
  if (LEAD_SOURCE_ICON_FILES[underscored]) {
    return LEAD_SOURCE_ICON_FILES[underscored];
  }

  const crmMatch = CRM_SOURCE_ICON_MATCHERS.find(({ needle }) => key.includes(needle));
  return crmMatch?.file ?? null;
}

export function isLeadSourceImage(source?: string | null): boolean {
  return !!getLeadSourceIconFile(source);
}

export function getLeadSourceImg(source?: string | null): string {
  const file = getLeadSourceIconFile(source);
  if (!file) {
    return '';
  }
  const filename = file.includes('.') ? file : `${file}.png`;
  return `/assets/img/icons/${filename}`;
}
